(function () {
  var STORAGE_KEY = 'sdp_cookie_consent_v2';
  var banner = document.getElementById('sdp-cookie-banner');
  if (!banner) return;

  function getConsent() {
    try {
      return localStorage.getItem(STORAGE_KEY);
    } catch (e) {
      return null;
    }
  }

  function saveConsent(value) {
    try {
      localStorage.setItem(STORAGE_KEY, value);
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('sdp:cookie-consent', { detail: { value: value } }));
  }

  function signalClarity(accepted) {
    window.clarity = window.clarity || function () {
      (window.clarity.q = window.clarity.q || []).push(arguments);
    };
    window.clarity('consentv2', {
      ad_Storage: accepted ? 'granted' : 'denied',
      analytics_Storage: accepted ? 'granted' : 'denied'
    });
    if (!accepted) window.clarity('consent', false);
  }

  function setShopifyConsent(accepted, callback) {
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
      callback(new Error('Shopify Customer Privacy API unavailable'));
      return;
    }

    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (error) {
        if (error || !window.Shopify.customerPrivacy) {
          callback(error || new Error('Shopify Customer Privacy API unavailable'));
          return;
        }

        window.Shopify.customerPrivacy.setTrackingConsent(
          {
            analytics: accepted,
            marketing: accepted,
            preferences: accepted
          },
          function () {
            callback(null);
          }
        );
      }
    );
  }

  function applyConsent(value) {
    var accepted = value === 'accepted';
    setShopifyConsent(accepted, function (error) {
      if (error) {
        document.dispatchEvent(new CustomEvent('sdp:cookie-consent-error', { detail: { error: error } }));
        return;
      }
      saveConsent(value);
      signalClarity(accepted);
      hideBanner();
      if (accepted) loadTracking();
    });
  }

  function hideBanner() {
    banner.classList.remove('is-visible');
    document.body.classList.remove('sdp-cookie-visible');
  }

  function showBanner() {
    banner.classList.add('is-visible');
    document.body.classList.add('sdp-cookie-visible');
  }

  function loadTracking() {
    if (window.__sdpTrackingLoaded) return;
    window.__sdpTrackingLoaded = true;
    document.dispatchEvent(new CustomEvent('sdp:load-tracking'));
  }

  var existing = getConsent();
  if (existing === 'accepted') {
    signalClarity(true);
    loadTracking();
    return;
  }
  if (existing === 'rejected') {
    signalClarity(false);
    return;
  }

  showBanner();

  banner.querySelector('[data-cookie-accept]')?.addEventListener('click', function () {
    applyConsent('accepted');
  });

  banner.querySelector('[data-cookie-reject]')?.addEventListener('click', function () {
    applyConsent('rejected');
  });
})();
